import EtiquetaForm from "./EtiquetaForm";
export default EtiquetaForm;
